import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dept-page" }
const _hoisted_2 = { class: "dept-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "dept-search-bar" }
const _hoisted_5 = {
  class: "dept-table-bar",
  style: {"text-align":"right","margin-bottom":"8px"}
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"#1677ff"}
}

import SystemSideMenu from '@/components/SystemSideMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DeptManager',
  setup(__props) {

const columns = [
  { title: '部门名称', dataIndex: 'name', key: 'name' },
  { title: '排序', dataIndex: 'order', key: 'order' },
  { title: '描述', dataIndex: 'desc', key: 'desc' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  { name: '研发中心', order: 1, desc: '', status: '启用' }
]

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dept-title" }, "部门管理", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form, { layout: "inline" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "部门名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        placeholder: "请输入部门名称",
                        style: {"width":"180px"}
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        style: {"margin-right":"8px"}
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("搜索")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("重置")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("新增")
                ])),
                _: 1
              })
            ]),
            _createVNode(_component_a_table, {
              columns: columns,
              "data-source": dataSource,
              pagination: false,
              size: "middle"
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.key === 'status')
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("启用")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (column.key === 'action')
                  ? (_openBlock(), _createElementBlock("a", _hoisted_6, "编辑"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})